module.exports = __webpack_public_path__ + "static/media/place-footer.2bc62565.svg";